import React, { Fragment, useState } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { Btn } from '../../../AbstractElements';
import {
    EmailAddress, ForgotPassword, Password, RememberPassword, SignIn,
    ContinueWithMagicLink, ContinueWithOTP,
} from '../../../Constant';
import { Link, useNavigate } from 'react-router-dom';
import FormHeader from './FormHeader';
import { toast } from 'react-toastify';
import axios from 'axios';
import API_BASE_URL from '../../../Config/api';
import { completeLogin } from '../../completeLogin';
import PasswordlessTab from '../PasswordlessTab';

const LoginTab = () => {
    const [mode, setMode] = useState('password'); // 'password' | 'magic_link' | 'otp'
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [togglePassword, setTogglePassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const loginAuth = async (e) => {
        e.preventDefault();
        if (!email || !password) {
            toast.error('Please enter your email and password.');
            return;
        }
        setLoading(true);
        try {
            const response = await axios.post(`${API_BASE_URL}/api/login`, { email, password });
            toast.success('Login Success!');
            completeLogin(navigate, response.data);
        } catch (error) {
            toast.error(error.response?.data?.error || 'Login failed!');
        } finally {
            setLoading(false);
        }
    }

    if (mode !== 'password') {
        return <PasswordlessTab intent={mode} onBack={() => setMode('password')} />;
    }

    return (
        <Fragment>
            <Form className="theme-form">
                <FormHeader />
                <FormGroup className='form-group'>
                    <Label className="col-form-label">{EmailAddress}</Label>
                    <Input className="form-control" value={email} type="email" onChange={e => setEmail(e.target.value)} />
                </FormGroup>
                <FormGroup className='form-group'>
                    <Label className="col-form-label">{Password}</Label>
                    <div className='form-input position-relative'>
                        <Input className="form-control" type={togglePassword ? 'text' : 'password'} autoComplete='' value={password} onChange={e => setPassword(e.target.value)} required />
                        <div className="show-hide" onClick={() => setTogglePassword(!togglePassword)}>
                            <span className={togglePassword ? '' : 'show'}></span>
                        </div>
                    </div>
                </FormGroup>
                <FormGroup className="form-group mb-0">
                    <div className="checkbox p-0">
                        <Input id="checkbox1" type="checkbox" />
                        <Label className="text-muted" for="checkbox1">{RememberPassword}</Label>
                    </div>
                    <Link className="link" to={`/forgot-password`}>{ForgotPassword}</Link>
                </FormGroup>
                <div className='text-end mt-3'>
                    <Btn attrBtn={{ color: 'primary w-100', className: 'btn-block', disabled: loading, onClick: (e) => loginAuth(e) }} >{loading ? 'Signing in...' : SignIn}</Btn>
                </div>
                <div className='text-center mt-3' style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <Btn attrBtn={{ color: 'link', className: 'p-0', type: 'button', onClick: () => setMode('magic_link') }}>{ContinueWithMagicLink}</Btn>
                    <Btn attrBtn={{ color: 'link', className: 'p-0', type: 'button', onClick: () => setMode('otp') }}>{ContinueWithOTP}</Btn>
                </div>
            </Form>
        </Fragment>
    );
};
export default LoginTab;
